/**
 * Получение CSV по id сектора
 * @param sectorId - ID сектора
 * @param type - тип данных ('flux' или 'thickness')
 * @returns Blob CSV-файла
 */
export async function apiFetchCsvForSector(sectorId: string, type: string): Promise<Blob | null> {
    try {
        const response = await fetch(`/csv/sector/${sectorId}?type=${type}`, {
            method: 'GET'
        });

        if (!response.ok) {
            console.error(`Ошибка ${response.status}`);
            return null;
        }

        // Возвращаем Blob для дальнейшей обработки
        return await response.blob();

    } catch (err) {
        console.error('Запрос CSV не удался', err);
        return null;
    }
}


/**
 * Получение графика по id сектора
 * @param {*} sectorId 
 * @returns 
 */
export async function apiFetchGraphsForSector(sectorId: string, type: string) {
    try {
        const response = await fetch(`/image/sector/${sectorId}?type=${type}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            console.error(`Ошибка ${response.status}`);
            return null;
        }

        return await response.json();
    } catch (err) {
        console.error('Запрос не удался', err);
        return null;
    }
}